import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface SendNotificationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function SendNotificationDialog({
  open,
  onOpenChange,
}: SendNotificationDialogProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      // Redirect to the new SendNotification page
      navigate("/admin/notifications/send");
      onOpenChange(false);
    }
  }, [open, navigate, onOpenChange]);

  // This component now just handles the redirect
  // The actual functionality is in the new SendNotification page
  return (
    <Dialog open={false} onOpenChange={() => {}}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send className="h-5 w-5" />
            Redirecting...
          </DialogTitle>
          <DialogDescription>
            Redirecting to the enhanced notification sending page.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => navigate("/admin/notifications/send")}>
            Go to Send Notifications
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
